import styled from 'styled-components'

export const StyledNotFound = styled.div``
